import request from "../utils/request";
/* eslint-disable */
export async function importFromExcel(excelArray) {
  return request.post("Bill/ImportExcel",excelArray);
}
export async function saveNewStocks(stock) {
  let payload = _.cloneDeep(stock);
  payload.totalDiscountType = payload.totalDiscountType.name;
  payload.billEntries.forEach(x=> x.discountType = x.discountType.name);
  return request.post("Bill/Create", payload);
}
export async function deleteBill(id){
  return request.delete("Bill/Delete?id="+id);
}
export async function submitPayment(newPayment) {
  return request.post("Bill/SubmitPayment", newPayment);
}
export async function getBillList(payload) {
  return request.get("Bill/List", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      billNo: payload.billNo,
      distributorId: payload.distributor != null ? payload.distributor.id : null,
      supplierId: payload.supplier != null ? payload.supplier.id : null,
      stockId: payload.stock != null ? payload.stock.id : null,
      stockCode: payload.stockCode,
      minTotalPrice: payload.price && payload.price.min ? payload.price.min : null,
      maxTotalPrice: payload.price && payload.price.max ? payload.price.max : null,
      branchId: payload.branch ? payload.branch.id : null,
      paymentMethodId: payload.paymentMethod ? payload.paymentMethod.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      status: payload.billStatus ? payload.billStatus.id : null
    }
  });
};

export async function getBillListForDealer(payload) {
  return request.get("Bill/ListForDealer", {
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      billNo: payload.billNo,
      distributorId: payload.distributor != null ? payload.distributor.id : null,
      supplierId: payload.supplier != null ? payload.supplier.id : null,
      stockId: payload.stock != null ? payload.stock.id : null,
      stockCode: payload.stockCode,
      minTotalPrice: payload.price && payload.price.min ? payload.price.min : null,
      maxTotalPrice: payload.price && payload.price.max ? payload.price.max : null,
      branchId: payload.branch ? payload.branch.id : null,
      paymentMethodId: payload.paymentMethod ? payload.paymentMethod.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      status: payload.billStatus ? payload.billStatus.id : null
    }
  });
};

export async function getExcelBill(payload) {
  return request.get("Bill/GetExcelBill", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      id:payload
    }
  })
}

export async function getExcelList(payload) {
 
  return request.get("Bill/GetExcelList", {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.ms-excel'
    },
    params: {
      sortBy: payload.sortBy,
      sortDirection: payload.sortDirection,
      pageIndex: payload.pageIndex,
      pageSize: payload.pageSize,
      billNo: payload.billNo,
      distributorId: payload.distributor != null ? payload.distributor.id : null,
      supplierId: payload.supplier != null ? payload.supplier.id : null,
      stockId: payload.stock != null ? payload.stock.id : null,
      stockCode: payload.stockCode,
      minTotalPrice: payload.price && payload.price.min ? payload.price.min : null,
      maxTotalPrice: payload.price && payload.price.max ? payload.price.max : null,
      branchId: payload.branch ? payload.branch.id : null,
      paymentMethodId: payload.paymentMethod ? payload.paymentMethod.id : null,
      startDate: payload.dateRange != null && payload.dateRange.startDate != null ? payload.dateRange.startDate.toDateString() : null,
      startTime: payload.timeRange != null && payload.timeRange.startTime != null ? payload.timeRange.startTime.HH + ':' + payload.timeRange.startTime.mm : null,
      endDate: payload.dateRange != null && payload.dateRange.endDate != null ? payload.dateRange.endDate.toDateString() : null,
      endTime: payload.timeRange != null && payload.timeRange.endTime != null ? payload.timeRange.endTime.HH + ':' + payload.timeRange.endTime.mm : null,
      status: payload.billStatus ? payload.billStatus.id : null
    }
  });
};
